import React, { useEffect, useState } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Row, Col, Form } from "react-bootstrap";
import { Link } from "react-router-dom";
import Footer from "./footer";
import Header from "./header";
import { toast } from "react-toastify";
import {
    examtitlelist,
    examstudentlist,
    stuacademicyearlist,
    stuclasslist,
    studivisionlist,
    stusubjectlist,
    studentfilter,
    studentmarkcreate,
    studentmarklist,
} from "../service/dashboard";

const StudentMarkEnter = () => {
    const [alist, setAList] = useState([]);
    const [clist, setCList] = useState([]);
    const [seclist, setSecList] = useState([]);
    const [tlist, setTList] = useState([]);
    const [slist, setSList] = useState([]);

    const [ayear, setAYear] = useState("");
    const [stucls, setStuCls] = useState("");
    const [stusec, setStuSec] = useState("");
    const [etitle, setETitle] = useState("");
    const [stusub, setStuSub] = useState("");

    const [students, setStudents] = useState([]);
    const [loading, setLoading] = useState(false);

    const [samePracticalForAll, setSamePracticalForAll] = useState(false);

    useEffect(() => {
        const temp = new FormData();
        temp.append("academy_id", localStorage.getItem("academy"));

        stuacademicyearlist(temp).then((res) => {
            if (res && res.status === true && res.data.length > 0) {
                const sorted = [...res.data].sort((a, b) => Number(b.id) - Number(a.id));
                setAList(sorted);
                setAYear(sorted[0].id);
            }
        });
        stuclasslist().then((res) => {
            if (res && res.status === true) setCList(res.data);
        });
        studivisionlist().then((res) => {
            if (res && res.status === true) setSecList(res.data);
        });
        examtitlelist(temp).then((res) => {
            if (res && res.status === true) setTList(res.data);
        });
        stusubjectlist(temp).then((res) => {
            if (res && res.status === true) setSList(res.data);
        });
    }, []);

    function clearList() {
        setStudents([]);
    }

    function searchStudents() {
        setStudents([]);
        if (ayear === "") { toast.error("Please Select Academic Year"); return; }
        if (stucls === "") { toast.error("Please Select Class"); return; }
        if (stusec === "") { toast.error("Please Select Section"); return; }
        if (etitle === "") { toast.error("Please Select Exam Title"); return; }
        if (stusub === "") { toast.error("Please Select Subject"); return; }

        setLoading(true);
        // 1. Verify an exam exists for this class/section/exam title/subject
        examstudentlist(1, 0).then((res) => {
            if (res && res.status === true) {
                const sdata = res.data.find(
                    (item) =>
                        item.exam_type == etitle &&
                        item.subject_id == stusub &&
                        item.class_id == stucls &&
                        item.section == stusec
                );

                if (sdata === undefined) {
                    setLoading(false);
                    toast.error("No exam created for this class, section, exam title and subject.");
                    return;
                }

                // 2. Get students in the class/section/year
                const temp = new FormData();
                temp.append("year", ayear);
                temp.append("class", stucls);
                temp.append("section", stusec);
                studentfilter(temp).then((res1) => {
                    if (res1 && res1.status === true) {
                        if (!res1.data.details || res1.data.details.length === 0) {
                            setLoading(false);
                            toast.warning("No student in this class and section for the selected year.");
                            return;
                        }

                        let arr = res1.data.details.map((s) => ({
                            id: s.user_id,
                            name: s.student_name,
                            type: "Present",
                            theory: "",
                            practical: "",
                        }));

                        // 3. Load any existing marks
                        const temp1 = new FormData();
                        temp1.append("year_id", ayear);
                        temp1.append("class_id", stucls);
                        temp1.append("section_id", stusec);
                        temp1.append("subject_id", stusub);
                        temp1.append("exam_title_id", etitle);
                        studentmarklist(temp1).then((res2) => {
                            if (res2 && res2.status === true && res2.data) {
                                arr = arr.map((item) => {
                                    const ud = res2.data.find((u) => u.user_id == item.id);
                                    if (ud) {
                                        return {
                                            ...item,
                                            type: ud.present_absent == 0 ? "Absent" : "Present",
                                            theory: ud.theory_mark,
                                            practical: ud.practical_mark,
                                        };
                                    }
                                    return item;
                                });
                            }
                            setStudents(arr);
                            setLoading(false);
                        });
                    } else {
                        setLoading(false);
                    }
                });
            } else {
                setLoading(false);
            }
        });
    }

    const handleTheory = (id, value) => {
        const regex = /^[0-9\b]*$/;
        if (!regex.test(value)) return;
        setStudents((prev) =>
            prev.map((item) => (item.id === id ? { ...item, theory: value } : item))
        );
    };

    const handlePractical = (id, value) => {
        const regex = /^[0-9\b]*$/;
        if (!regex.test(value)) return;
        if (samePracticalForAll) {
            setStudents((prev) => prev.map((item) => ({ ...item, practical: value })));
        } else {
            setStudents((prev) =>
                prev.map((item) => (item.id === id ? { ...item, practical: value } : item))
            );
        }
    };

    const handleType = (id, value) => {
        setStudents((prev) =>
            prev.map((item) => (item.id === id ? { ...item, type: value } : item))
        );
    };

    const setAllType = (value) => {
        setStudents((prev) => prev.map((item) => ({ ...item, type: value })));
    };

    const submitAll = () => {
        const isValid = students.every((item) => item.theory !== "" && item.type);
        if (!isValid) {
            toast.error("Please enter theory marks and present/absent for each student.");
            return;
        }

        setLoading(true);
        const promises = students.map((item) => {
            const temp = new FormData();
            temp.append("user_id", item.id);
            temp.append("year_id", ayear);
            temp.append("class_id", stucls);
            temp.append("section_id", stusec);
            temp.append("subject_id", stusub);
            temp.append("exam_title_id", etitle);
            temp.append("present_absent", item.type === "Present" ? 1 : 0);
            temp.append("theory_mark", item.theory);
            temp.append("practical_mark", item.practical || 0);
            return studentmarkcreate(temp);
        });

        Promise.all(promises)
            .then((responses) => {
                const hasError = responses.some((res) => !res || res.status !== true);
                if (hasError) {
                    toast.error("Some records failed to save.");
                } else {
                    toast.success("All student marks saved successfully.");
                }
                searchStudents();
            })
            .catch(() => {
                toast.error("An unexpected error occurred while saving marks.");
            })
            .finally(() => setLoading(false));
    };

    return (
        <div id="mainpage">
            <div className="maincontent">
                <Header />

                <div className="moreheading">
                    <Row className="row-sm">
                        <Col xs={8} className="text-left align-self-end">
                            <h4 className="morehead-text">Student Mark Entry</h4>
                        </Col>
                        <Col xs={4} className="text-right align-self-end">
                            <Link to={"/dashboard"} className="btn-outline-success red-btn btn-sm">
                                <i className="fa-solid fa-hand-point-left"></i> Go Back
                            </Link>
                        </Col>
                    </Row>
                </div>

                {/* Filters */}
                <div className="p-3">
                    <Row className="mb-2">
                        <Col xs={6} className="mb-2">
                            <Form.Label>Academic Year</Form.Label>
                            <Form.Select
                                value={ayear}
                                onChange={(e) => { setAYear(e.target.value); clearList(); }}
                            >
                                <option value="" disabled> Select Academic Year</option>
                                {alist.map((item) => (
                                    <option key={item.id} value={item.id}>{item.aca_year}</option>
                                ))}
                            </Form.Select>
                        </Col>
                        <Col xs={6} className="mb-2">
                            <Form.Label>Class</Form.Label>
                            <Form.Select
                                value={stucls}
                                onChange={(e) => { setStuCls(e.target.value); clearList(); }}
                            >
                                <option value="" disabled> Select Class</option>
                                {clist.map((item) => (
                                    <option key={item.id} value={item.id}>{item.class_name}</option>
                                ))}
                            </Form.Select>
                        </Col>
                        <Col xs={6} className="mb-2">
                            <Form.Label>Section</Form.Label>
                            <Form.Select
                                value={stusec}
                                onChange={(e) => { setStuSec(e.target.value); clearList(); }}
                            >
                                <option value="" disabled> Select Section</option>
                                {seclist.map((item) => (
                                    <option key={item.id} value={item.id}>{item.name}</option>
                                ))}
                            </Form.Select>
                        </Col>
                        <Col xs={6} className="mb-2">
                            <Form.Label>Exam Title</Form.Label>
                            <Form.Select
                                value={etitle}
                                onChange={(e) => { setETitle(e.target.value); clearList(); }}
                            >
                                <option value="" disabled> Select Exam Title</option>
                                {tlist.map((item) => (
                                    <option key={item.id} value={item.id}>{item.exam_title}</option>
                                ))}
                            </Form.Select>
                        </Col>
                        <Col xs={6} className="mb-2">
                            <Form.Label>Subject</Form.Label>
                            <Form.Select
                                value={stusub}
                                onChange={(e) => { setStuSub(e.target.value); clearList(); }}
                            >
                                <option value="" disabled> Select Subject</option>
                                {slist.map((item) => (
                                    <option key={item.id} value={item.id}>{item.subject_name}</option>
                                ))}
                            </Form.Select>
                        </Col>
                        <Col xs={6} className="align-self-end mb-2">
                            <button className="btn btn-success w-100" onClick={searchStudents}>
                                <i className="fa fa-search"></i> Search
                            </button>
                        </Col>
                    </Row>

                    {students.length > 0 && (
                        <>
                            <div className="d-flex flex-wrap gap-3 align-items-center mb-2 p-2 rounded" style={{ backgroundColor: "#f8f9fa" }}>
                                <Form.Check
                                    type="checkbox"
                                    id="samePractical"
                                    label="Same practical for all"
                                    checked={samePracticalForAll}
                                    onChange={(e) => setSamePracticalForAll(e.target.checked)}
                                />
                                <button className="btn btn-sm btn-outline-success" onClick={() => setAllType("Present")}>All Present</button>
                                <button className="btn btn-sm btn-outline-danger" onClick={() => setAllType("Absent")}>All Absent</button>
                            </div>

                            <div className="table-responsive">
                                <table className="table table-bordered table-sm text-nowrap mb-0">
                                    <thead>
                                        <tr>
                                            <th>Student</th>
                                            <th>Theory</th>
                                            <th>Practical</th>
                                            <th>Present/Absent</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {students.map((item) => (
                                            <tr key={item.id}>
                                                <td>{item.name}</td>
                                                <td>
                                                    <Form.Control
                                                        type="number"
                                                        value={item.theory}
                                                        onChange={(e) => handleTheory(item.id, e.target.value)}
                                                        placeholder="Theory"
                                                    />
                                                </td>
                                                <td>
                                                    <Form.Control
                                                        type="number"
                                                        value={item.practical}
                                                        onChange={(e) => handlePractical(item.id, e.target.value)}
                                                        placeholder="Practical"
                                                    />
                                                </td>
                                                <td>
                                                    <Form.Select
                                                        value={item.type ?? "Present"}
                                                        onChange={(e) => handleType(item.id, e.target.value)}
                                                    >
                                                        <option value="Present">Present</option>
                                                        <option value="Absent">Absent</option>
                                                    </Form.Select>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>

                            <div className="text-end mt-3">
                                <button className="btn btn-success" onClick={submitAll} disabled={loading}>
                                    {loading ? "Saving..." : "Submit"}
                                </button>
                            </div>
                        </>
                    )}

                    {loading && students.length === 0 && (
                        <p className="text-center text-muted mt-3">Loading...</p>
                    )}
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default StudentMarkEnter;
